import { Button, Icon, Message, Step } from 'semantic-ui-react';
import { AM, FINANCE, LEVEL_NAME, canApprove, describe } from '../approvals.js';

/* The approval steps for the period on screen. A step that is already done is not shown as a box to act on: it becomes a one-line note
 * saying who approved and when. Downloads appear only when both are done. */
export default function ApprovalPanel({ period, report, status, user, busy, hasFigures, onApprove, onDownload, storage }) {
  const complete = status.stage === 'complete';
  const done = [FINANCE, AM].filter((level) => status[level]);
  const todo = [FINANCE, AM].filter((level) => !status[level]);
  const step = (level) => {
    const check = canApprove(user, level, report, status);
    const waiting = level === AM && !status.finance;
    return (
      <Step key={level} active={!waiting} disabled={waiting} as="div">
        <Icon name="circle outline" />
        <Step.Content>
          <Step.Title>{level === FINANCE ? 1 : 2}. {LEVEL_NAME[level]} approval</Step.Title>
          <Step.Description>
            {waiting ? 'Available after Finance approval' : 'Not yet approved'}
            <div className="stepaction">
              <Button positive compact size="small" type="button" icon="check" labelPosition="left" content={`Approve as ${LEVEL_NAME[level]}`}
                disabled={!check.ok || !!busy || !hasFigures} loading={busy === level} onClick={() => onApprove(level)} />
              {!check.ok && !waiting && <div className="hint">{check.reason}</div>}
              {check.ok && !hasFigures && <div className="hint">No figures in this period.</div>}
            </div>
          </Step.Description>
        </Step.Content>
      </Step>
    );
  };
  return (
    <section className="approvalpanel" aria-labelledby="appr-heading">
      <h3 id="appr-heading" className="ui small header">Approval – {period.title}</h3>
      {done.length > 0 && (
        <ul className="approvaldone" aria-label="Approvals already given">
          {done.map((level) => (
            <li key={level}><Icon name="check circle" color="green" /><strong>{LEVEL_NAME[level]} approved</strong> by {describe(status[level])}</li>
          ))}
        </ul>
      )}
      {todo.length > 0 && <Step.Group fluid stackable="tablet" widths={todo.length}>{todo.map(step)}</Step.Group>}
      {complete ? (
        <div className="toolbar" role="group" aria-label="Downloads">
          <Button type="button" icon="file excel outline" labelPosition="left" content="Download Excel" loading={busy === 'xlsx'} disabled={!!busy} onClick={() => onDownload('xlsx')} />
          <Button type="button" icon="file pdf outline" labelPosition="left" content="Download PDF" loading={busy === 'pdf'} disabled={!!busy} onClick={() => onDownload('pdf')} />
        </div>
      ) : (
        <Message info size="small" role="note">Download PDF and Download Excel appear once both Finance and the Account Manager have approved this period.</Message>
      )}
      <p className="hint">Approvals are recorded with the person and the date and time, in {storage}.</p>
    </section>
  );
}
